import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { ConsultarPreguntasService } from "../administrador-preguntas/consultar-preguntas.service";
import { ConflictosService } from "../administrador-conflictos/servicios/conflictos.service";
import { MatTableDataSource, MatPaginator } from "@angular/material";
import { Globals } from "src/app/globals";
import Swal from "sweetalert2";
import { Router } from "@angular/router";

import { of, Subscription } from 'rxjs';
import { EventoscomService } from '../servicios/eventoscom.service';
import { DOCUMENT } from '@angular/common';
import { isNgTemplate } from "@angular/compiler";

@Component({
  selector: "app-administrador-preguntas",
  templateUrl: "./administrador-preguntas.component.html",
  styleUrls: ["./administrador-preguntas.component.css"]
})
export class AdministradorPreguntasComponent implements OnInit {


  message: any;
  //subscription: Subscription;

  ocultarNoConflicto = true;


  constructor(

    private ConsultarPreguntas: ConsultarPreguntasService,
    public global: Globals,
    private conflictosService: ConflictosService,
    private router: Router,
    private eventoscomService: EventoscomService,
    private cg: ChangeDetectorRef
  ) {

  //  this.subscription = this.eventoscomService.getMessage().subscribe(message => { this.RecargarCampos(); this.message = message; });


  }



  myHTML = `

  <b>This is my awesome bold text</b>
  <b>This is my awesome bold text</b>
  <b>This is my awesome bold text</b>
  <b>This is my awesome bold text</b>

  `;


  //

  respuestaSeleccionada2;
  respuestaSeleccionada3;
  respuestaSeleccionada4;
  respuestaSeleccionada5;
  respuestaSeleccionada6;
  respuestaSeleccionada7;
  respuestaSeleccionada8;
  respuestaSeleccionada9;
  respuestaSeleccionada10;
  respuestaSeleccionada11;
  respuestaSeleccionada12;
  respuestasNo = [];
  listaConflictoEditar = []

  //#region "Variables Globales"


  operacionSeleccionadaPregunta13;
  operacionSeleccionadaPregunta14;
  operacionSeleccionadaPregunta15;
  operacionSeleccionadaPregunta16;
  operacionSeleccionadaPregunta17;
  operacionSeleccionadaPregunta18;
  operacionSeleccionada;

  Pregunta19Checkbox1 = false;
  Pregunta19Checkbox2 = false;
  Pregunta19Checkbox3 = false;
  Pregunta19Checkbox4 = false;
  Pregunta19Checkbox5 = false;

  Pregunta20Checkbox1 = false;



  BotonEditarPregunta = false;
  BotonInformacion = false;
  LabelParaRegistrar = false;
  BotonCrearNuevoConflicto = false;
  BotonAnterior = false;
  BotonSiguiente = false;
  BotonFinalizar = false;


  FaltaAccion = false;
  FaltaSiNO = true;


  PreguntaTipo1 = false;
  PreguntaTipo2 = false;
  VisibleBotones = false;
  PreguntaTipo3 = false;

  PreguntaTipo4 = false;

  Checkboxterminos1 = true;
  Checkboxterminos2 = false;

  Pregunta1Accion;

  Pregunta1CampoV;

  tipoPregunta;
  BotonPermaneceConCambiosTexto;
  BotonEditarTexto;
  BotonConflictopermaneceigualTexto;
  BotonConflictoyanoexisteTexto;
  BotonEditarPreguntaTexto;
  BotonCrearNuevoConflictoTexto;

  BotonAnteriorTexto;
  BotonSiguienteTexto;
  BotonFinalizarTexto;
  BotonFinalizarEncuestaTexto;
  TextoParaRegistrar;
  BotonInformacionTexto;
  AnnioActual;
  funcionariosok = null;
  respuestaSeleccionada;
  esUnico = true;
  ArrayPregunta4A;

  respuestas4 = []
  respuestas5 = []

  tituloInfo = {
    es: `<h5>Guía General Encuesta Conflictos de Interés</h5>`,
    en: `<h5>General Guide - Conflict of Interests Survey</h5>`
  };

  informacion = {
    es: `<h5><u>1. Definiciones e Interpretación de Conflicto de Interés: </u></h5>
  <p align="justify">
    Un conflicto de interés es aquella situación en la cual una persona que desempeña una función para FRONTERA tiene un
    interés privado, personal o profesional que puede afectar su juicio y ejercer influencia en el ejercicio de sus
    deberes.
  </p>
  <p align="justify">
    Los conflictos de interés son reales, percibidos o potenciales. Un conflicto de interés real ocurre cuando la
    decisión que toma una persona que desempeña una función para FRONTERA, tiene un impacto favorable sobre un interés
    privado (personal o profesional). Un conflicto de interés percibido es aquella situación en la que cualquier persona
    que conoce los hechos, consideraría que existe un conflicto de interés, sea o no el caso. Un conflicto de interés
    potencial existe cuando la decisión que toma hoy una persona que desempeña una función para FRONTERA, podría tener
    un impacto favorable sobre un interés privado en el futuro.
  </p>

  <h5><u>2. Ejemplos y escenarios de Conflicto de Interés: </u></h5>
  <p align="justify">Las siguientes situaciones son ejemplos de conflictos de interés:</p>
  <ul>
  <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Involucramiento en actividades comerciales o personales que directa o indirectamente están en conflicto o impactan
      la Compañía o sus intereses de cualquier forma.
    </li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">Relaciones con funcionarios públicos o entidades que son propiedad del Estado.</li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Asociación con personas o empresas que podrían, de cualquier forma, beneficiarse con las decisiones de la
      Compañía.
    </li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Uso de cualquier información confidencial (información que no está disponible al público de forma general) de la
      Compañía para beneficio personal.
    </li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Ejercer influencia sobre las políticas o decisiones de la Compañía para beneficio personal o de un tercero.
    </li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Usar el vínculo que se tiene con la Compañía para obtener ganancia, intentar obtener ganancia, o cualquier
      beneficio personal o para familiares o amigos.
    </li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Dar asesoría a la Compañía buscando impactar a otras organizaciones con las cuales la Compañía está involucrada.
    </li>

    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Invertir en cualquier competidor de la Compañía, o cualquier empresa que hace negocios o que busca hacer negocios
      con la Compañía, distinto a inversiones relativamente menores en títulos valores poseídos por el público en
      general.
    </li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">Trabajar para, o a nombre de, cualquiera de las empresas mencionadas en el punto anterior.</li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Adjudicar los negocios de la Compañía a familiares o amigos, o trabajar en un proyecto de la Compañía que tendrá
      un impacto directo sobre los intereses de familiares o amigos.
    </li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Usar los recursos de la Compañía, incluyendo teléfonos, e-mail e Internet, para resolver asuntos personales, salvo
      que dicho uso sea razonable y no interrumpa el flujo de trabajo ni genere costos adicionales a la Compañía.
    </li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Participar en las actividades regulatorias u otras actividades de un ente comunitario o gubernamental que tengan
      un impacto directo sobre los negocios de la Compañía, salvo que esté debidamente autorizado.
    </li>

    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">Contratar o supervisar a un familiar o amigo.</li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Ejercer el cargo de director, funcionario, socio, consultor, o cualquier otro rol significativo, en cualquier
      competidor, proveedor, o cliente de la Compañía, o en cualquier entidad u organización con la cual la Compañía
      negocia o busca negociar.
    </li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Actuar como corredor o intermediario para beneficio de un tercero en las transacciones que involucran a la
      Compañía.
    </li>
  </ul>`,
    en: `<h5><u>1. Definitions and Interpretation: </u></h5>
    <p align="justify">
      A conflict of interest is defined as a situation where Personnel have a private, personal, professional or
      vested interest sufficient to influence the exercise of their duties at the Corporation. If this competing
      interest can potentially interfere with the proper exercise of judgment, then a conflict of interest exists.
    </p>
    <p align="justify">
      Conflicts of interest might be actual, perceived or potential. An actual conflict of interest occurs when
      advice given or an action taken has a direct and predictable impact on a private, personal, professional or
      vested interest. A perceived conflict of interest occurs when a reasonable person, knowing the facts, would
      consider that a conflict of interest may exist, whether or not this is the case. A potential conflict of
      interest exists when advice given or an action taken might have an impact on a private, personal,
      professional or vested interest in the future.
    </p>

    <h5><u>2. Examples and some scenarios of a Conflict of Interest: </u></h5>
    <p align="justify">
      Examples of circumstances that can give rise to a conflict of interest for Personnel include (but are not
      limited to):
    </p>
    <ul>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Involvement in business or personal activities that directly or indirectly conflict with or impact the
        Corporation or its interests in any way;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">Relationships with government officials or state-owned entities;</li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Association with individuals or businesses that may in any way benefit from decisions of the Corporation;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Use of any confidential information (i.e., information that is not generally available to the public) of
        the Corporation for personal benefit;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Attempts to influence the Corporation’s policies or decisions for personal benefit or the benefit of a
        third party;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Using association with the Corporation to gain, or attempt to gain, any personal benefit or benefit for
        family or friends;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Providing advice to the Corporation that will impact other organizations with which Personnel are
        involved.
      </li>
    </ul>

    <p align="justify">
      Some scenarios that may pose potential conflict of interest problems include, but are not limited to, the
      following:
    </p>

    <ul>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Investing in any competitor company to the Corporation, or any company doing or seeking to do business
        with the Corporation, other than relatively small investments in securities widely held by the general
        public;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">Working for, or on behalf of, any company referred to in the preceding bullet;</li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Placing the Corporation’s business with relatives or friends, or working on a project of the Corporation
        that will have a direct impact on the financial interests of relatives or friends;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Using the Corporation’s resources, including telephones, e-mail and Internet, for dealing with personal
        matters, unless such usage is reasonable and does not disrupt the flow of work or result in additional
        costs for the Corporation;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Borrowing money from companies doing or seeking to do business with the Corporation other than on
        generally available terms;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Participating in the regulatory or other activities of a community or governmental body that have a direct
        impact on the business of the Corporation unless authorized by the Corporation;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">Hiring or supervising a relative or friend;</li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Serving as a director, officer, partner, consultant, or in any other significant role, in any competitor,
        supplier, or customer of the Corporation, or any entity or organization with which the Corporation does
        business or seeks to do business; and
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Acting as a broker, finder or other intermediary for the benefit of a third party in transactions
        involving the Corporation or its interests.
      </li>
    </ul>`
  };
  //#endregion "Variables Globales"

  //#region "Funciones Generales"
  ngOnInit() {


    this.global.lugarConflicto = 1;

    this.AnnioActual = new Date().getFullYear();
    this.ConsultarTodasLasPreguntas(this.global.PreguntaActual);

  }

  convertirfecha(datein) {

    let dateString = (datein);
    let newDate;

    if (dateString && isNaN(dateString)) {
      newDate = new Date(dateString).toLocaleDateString();
      if (newDate == "Invalid Date") {
        newDate = datein;
      }
    } else {
      newDate = +dateString
    }

    return newDate;
  }

  RecargarCampos() {

    this.ConsultaCamposPregunta(this.global.idconflictoActual);

  }

  informacionEncuesta() {
    Swal.fire({
      title: this.tituloInfo[this.global.lenguaje],
      type: "info",
      html: this.informacion[this.global.lenguaje],
      width: "800px"
    });
  }

  public ConsultarTodasLasPreguntas(NumeroOrdenConflicto) {



    switch (NumeroOrdenConflicto) {
      case "20": {

        this.Checkboxterminos1 = false;
        this.Checkboxterminos2 = true;


        break;
      }

      default: {
        this.Checkboxterminos1 = true;
        this.Checkboxterminos2 = false;
        break;
      }
    }



    this.ConsultarPreguntas.ConsultarTodasLasPreguntas(
      NumeroOrdenConflicto
    ).subscribe(ArrayResultados => {
      ArrayResultados;

      //this.global.lenguaje = "es";


      let tipoconflicto = ArrayResultados[0].TipoPregunta;
      this.global.idconflictoActual = ArrayResultados[0].idtbl_conflicto;

      this.ConsultaCamposPregunta(this.global.idconflictoActual);


      switch (tipoconflicto) {
        case 1: {


          this.BotonEditarPregunta = false;
          this.BotonInformacion = false;
          this.LabelParaRegistrar = false;
          this.BotonCrearNuevoConflicto = false;
          this.BotonAnterior = false;
          this.BotonSiguiente = true;



          this.PreguntaTipo1 = true;
          this.PreguntaTipo2 = false;
          this.VisibleBotones = false;
          this.PreguntaTipo3 = false;
          this.PreguntaTipo4 = false;

          break;
        }
        case 2: {
          this.BotonEditarPregunta = false;
          this.BotonInformacion = true;
          this.LabelParaRegistrar = true;
          this.BotonCrearNuevoConflicto = true;
          this.BotonAnterior = true;
          this.BotonSiguiente = true;



          this.PreguntaTipo1 = false;
          this.PreguntaTipo2 = true;
          this.VisibleBotones = true;
          this.PreguntaTipo3 = false;
          this.PreguntaTipo4 = false;
          break;
        }
        case 3: {
          this.BotonEditarPregunta = false;
          this.BotonInformacion = true;
          this.LabelParaRegistrar = false;
          this.BotonCrearNuevoConflicto = false;
          this.BotonAnterior = true;
          this.BotonSiguiente = true;



          this.PreguntaTipo1 = false;
          this.PreguntaTipo2 = false;
          this.VisibleBotones = false;
          this.PreguntaTipo3 = true;
          this.PreguntaTipo4 = false;
          break;
        }
        case 4: {
          this.BotonEditarPregunta = false;
          this.BotonInformacion = true;
          this.LabelParaRegistrar = false;
          this.BotonCrearNuevoConflicto = false;
          this.BotonAnterior = true;
          this.BotonSiguiente = true;



          this.PreguntaTipo1 = false;
          this.PreguntaTipo2 = false;
          this.VisibleBotones = false;
          this.PreguntaTipo3 = false;
          this.PreguntaTipo4 = true;
          break;
        }
        default: {
          //statements;
          break;
        }
      }

      //////conole.log("PREGUNTA ACTUAL", this.global.PreguntaActual);

      switch (this.global.PreguntaActual) {



        case "20": {

          this.BotonFinalizar = true;
          this.BotonSiguiente = false;

          break;
        }
        default: {
          this.BotonFinalizar = false;
          break;
        }
      }




      if (
        this.global.lenguaje == "es" ||
        this.global.lenguaje == "ESPANOL" ||
        this.global.lenguaje == "ESPAÑOL"
      ) {


        this.TituloPregunta1 = ArrayResultados[0].tipo_conflicto_espanol;
        this.TituloParrafo1_1 = ArrayResultados[0].nombre;
        this.TituloParrafo1_2 = ArrayResultados[0].DescripcionPregunta;
        this.TituloParrafo1_3 = ArrayResultados[0].Texto1ES;
        this.TituloParrafo1_4 = ArrayResultados[0].Texto2ES;
        this.TituloParrafo1_5 = ArrayResultados[0].Texto3ES;
        this.TituloParrafo1_6 = ArrayResultados[0].Texto4ES;
        this.TituloParrafo1_7 = ArrayResultados[0].Texto5ES;
        this.InstruccionesDellenado = ArrayResultados[0].sideclarasteEspanol;

        this.AlgunInconveniente = "Si tienes algún inconveniente, haz clic aquí.";

        this.Pregunta1Accion = "Acción";

        this.BotonEditarTexto = "Editar Conflicto";
        this.BotonPermaneceConCambiosTexto =
          "Conflicto permanece pero con cambios";
        this.BotonConflictopermaneceigualTexto = "Conflicto permanece igual";
        this.BotonConflictoyanoexisteTexto = "Conflicto ya no existe";

        this.BotonEditarPreguntaTexto = "Editar Pregunta";
        this.BotonInformacionTexto = "Instructivo";
        this.BotonCrearNuevoConflictoTexto = "Si";
        this.BotonAnteriorTexto = "Anterior Pregunta";
        this.BotonSiguienteTexto = "Siguiente Pregunta";
        this.BotonFinalizarTexto = "FINALIZAR ENCUESTA";

        this.BotonFinalizarEncuestaTexto = "Finalizar Encuesta";

        this.TextoParaRegistrar = `Si tienes un nuevo conflicto de interés por reportar, haz clic en "SI". En caso contrario, haz clic en “NO”.`;
      } else {

        this.TituloPregunta1 = ArrayResultados[0].tipo_conflicto_ingles;
        this.TituloParrafo1_1 = ArrayResultados[0].ingles;
        this.TituloParrafo1_2 = ArrayResultados[0].InglesDescripcionPregunta;
        this.TituloParrafo1_3 = ArrayResultados[0].Texto1EN;
        this.TituloParrafo1_4 = ArrayResultados[0].Texto2EN;
        this.TituloParrafo1_5 = ArrayResultados[0].Texto3EN;
        this.TituloParrafo1_6 = ArrayResultados[0].Texto4EN;
        this.TituloParrafo1_7 = ArrayResultados[0].Texto5EN;
        this.InstruccionesDellenado = ArrayResultados[0].sideclarasteIngles;

        this.AlgunInconveniente = "If you have any problem, click here.";

        this.Pregunta1Accion = "Action";
        this.BotonEditarTexto = "Edit Conflict";
        this.BotonPermaneceConCambiosTexto = "Conflict remains, but changed";
        this.BotonConflictopermaneceigualTexto = "Conflict remains the same";
        this.BotonConflictoyanoexisteTexto = "Conflict does not exist";

        this.BotonEditarPreguntaTexto = "Edit Question";
        this.BotonInformacionTexto = "Guideline";
        this.BotonCrearNuevoConflictoTexto = "Yes";
        this.BotonAnteriorTexto = "Previous Question";
        this.BotonSiguienteTexto = "Next Question";

        this.BotonFinalizarTexto = "END SURVEY";

        this.TextoParaRegistrar =
          `If you have any additional conflicts for reporting, please click "YES". Otherwise, click "NO".`;
      }

      this.cg.detectChanges();

    });
  }
  //#endregion "Funciones Generales"

  //#region "Variables Pregunta1"
  Arraypregunta1;
  dataSourcePregunta1 = new MatTableDataSource([]);
  displayedColumnsPregunta1: string[];
  VisiblePregunta1 = true;

  Arraypregunta2;
  dataSourcePregunta2 = new MatTableDataSource([]);
  displayedColumnsPregunta2: string[];
  VisiblePregunta2 = true;

  TituloPregunta1;
  TituloParrafo1_1;
  TituloParrafo1_2;
  TituloParrafo1_3;
  TituloParrafo1_4;
  TituloParrafo1_5;
  TituloParrafo1_6;
  TituloParrafo1_7;
  TituloParrafo1_8;
  TituloParrafo1_9;
  InstruccionesDellenado;
  AlgunInconveniente;

  Pregunta1Campo1;
  Pregunta1Campo2;
  Pregunta1Campo3;
  Pregunta1Campo4;
  Pregunta1Campo5;
  Pregunta1Campo6;
  Pregunta1Campo7;
  Pregunta1Campo8;

  Pregunta1ID;
  Pregunta1annio;

  Pregunta2Campo1;
  Pregunta2Campo2;
  Pregunta2Campo3;
  Pregunta2Campo4;
  Pregunta2Campo5;
  Pregunta2Campo6;
  Pregunta2Campo7;
  Pregunta2Campo8;
  Pregunta2CampoV;

  Pregunta2ID;
  Pregunta2annio;

  //#endregion "Variables Pregunta1"

  //#region "Funciones Pregunta1"



  EditarPregunta1() {
    this.tipoPregunta = this.global.idconflictoActual;
    this.global.PrincipalAdministradorpreguntas = false;
    this.global.ActualizarPregunta = true;
  }

  NuevoConflictoPregunta1() {

    this.FaltaSiNO = false;

    this.EstilobotonNo = false;

    this.global.conflictosEditarDesdeEncuesta = true;

    this.tipoPregunta = this.global.idconflictoActual;
    this.global.NuevoConflicto = true;
    this.global.EditarConflicto = false;
    this.global.conflictosEditarConflicto = false;
    this.global.PrincipalAdministradorpreguntas = false;
  }

  EstilobotonNo = false;

  RespuestaNo() {

    this.EstilobotonNo = true;
    this.FaltaSiNO = false;


    var CamposObject = {};
    CamposObject["29"] = "NO";


    let data = {
      id_funcionario: this.global.IdFuncionarioTablaFuncionarios,
      estado: "1",
      es_nuevo: "1",
      id_conflicto: this.global.idconflictoActual,
      annio: this.AnnioActual,
      lugarConflicto: this.global.lugarConflicto,
      CamposObject
    }

    let encontrado = false
    for (let item of this.respuestasNo) {
      if (item.id_conflicto == data.id_conflicto) {
        //////conole.log("Ya existe")
        encontrado = true;
      }
    }

    if (!encontrado) {
      let etiquetaCargando = { es: "Guardando", en: "Saving" };
      Swal.fire(etiquetaCargando[this.global.lenguaje]);
      Swal.showLoading();

      this.conflictosService
        .crearConflicto(this.global.IdFuncionarioTablaFuncionarios, data.id_conflicto, data.CamposObject, this.global.lugarConflicto)
        .subscribe(datos => {

          console.log(datos)
          this.respuestasNo.push(data)
          Swal.close();
        }, error => {
          console.log(error)
        });
    }


    console.log(this.respuestasNo)
  }

  PermaneceConCambiosPregunta1(
    idcampo,
    idconflicto,
    valorCampo1,
    valorCampo2,
    valorCampo3,
    valorCampo4,
    valorCampo5,
    valorCampo6,
    valorCampo7,
    valorCampo8,
    IdCampo1,
    IdCampo2,
    IdCampo3,
    IdCampo4,
    IdCampo5,
    IdCampo6,
    IdCampo7,
    IdCampo8

  ) {

    if (idcampo == "0") {
      this.ConsultarPreguntas.InsertarValorConflicto(
        idconflicto,
        "Conflicto permanece pero ha tenido cambios"
      ).subscribe(ArrayResultados => {
        this.ConsultaCamposPregunta(this.global.idconflictoActual);
      });
    } else {
      this.ConsultarPreguntas.ActualizarValorConflictoCerrado(
        idcampo,
        "Conflicto permanece pero ha tenido cambios"
      ).subscribe(ArrayResultados => {
        this.ConsultaCamposPregunta(this.global.idconflictoActual);
      });
    }

    this.tipoPregunta = this.global.idconflictoActual;

    //////conole.log("------------------------------");
    //////conole.log(valorCampo1);
    //////conole.log(valorCampo2);
    //////conole.log(valorCampo3);
    //////conole.log(valorCampo4);
    //////conole.log(valorCampo5);
    //////conole.log(valorCampo6);
    //////conole.log(valorCampo7);
    //////conole.log(valorCampo8);

    //////conole.log("------------------------------");


    //////conole.log(IdCampo1);
    //////conole.log(IdCampo2);
    //////conole.log(IdCampo3);
    //////conole.log(IdCampo4);
    //////conole.log(IdCampo5);
    //////conole.log(IdCampo6);
    //////conole.log(IdCampo7);
    //////conole.log(IdCampo8);

    //////conole.log("------------------------------");




    switch (this.tipoPregunta) {
      case 1: {

        this.respuestaSeleccionada = {
          3: {
            valor: valorCampo1,
            idRespuestaIndividual: IdCampo1,
            idRespuestaConflicto: idconflicto
          },
          4: {
            valor: valorCampo2,
            idRespuestaIndividual: IdCampo2,
            idRespuestaConflicto: idconflicto
          },
          19: {
            valor: valorCampo3,
            idRespuestaIndividual: IdCampo3,
            idRespuestaConflicto: idconflicto
          }
        };

        //////conole.log(this.respuestaSeleccionada);

        break;
      }

      case 11: {

        this.respuestaSeleccionada = {
          43: {
            valor: valorCampo1,
            idRespuestaIndividual: IdCampo1,
            idRespuestaConflicto: idconflicto
          },
          4: {
            valor: valorCampo2,
            idRespuestaIndividual: IdCampo2,
            idRespuestaConflicto: idconflicto
          },
          2: {
            valor: valorCampo3,
            idRespuestaIndividual: IdCampo3,
            idRespuestaConflicto: idconflicto
          },
          1: {
            valor: valorCampo4,
            idRespuestaIndividual: IdCampo4,
            idRespuestaConflicto: idconflicto
          },
          19: {
            valor: valorCampo5,
            idRespuestaIndividual: IdCampo5,
            idRespuestaConflicto: idconflicto
          }
        };


        //////conole.log(this.respuestaSeleccionada);

        break;
      }

      case 2: {

        this.respuestaSeleccionada = {
          19: {
            valor: valorCampo1,
            idRespuestaIndividual: IdCampo1,
            idRespuestaConflicto: idconflicto
          }
        };

        //////conole.log(this.respuestaSeleccionada);

        break;
      }


      case 3: {

        this.respuestaSeleccionada = {
          25: {
            valor: valorCampo1,
            idRespuestaIndividual: IdCampo1,
            idRespuestaConflicto: idconflicto
          },
          23: {
            valor: valorCampo2,
            idRespuestaIndividual: IdCampo2,
            idRespuestaConflicto: idconflicto
          },
          22: {
            valor: valorCampo3,
            idRespuestaIndividual: IdCampo3,
            idRespuestaConflicto: idconflicto
          },
          35: {
            valor: valorCampo4,
            idRespuestaIndividual: IdCampo4,
            idRespuestaConflicto: idconflicto
          },
          36: {
            valor: valorCampo5,
            idRespuestaIndividual: IdCampo5,
            idRespuestaConflicto: idconflicto
          },
          38: {
            valor: valorCampo6,
            idRespuestaIndividual: IdCampo6,
            idRespuestaConflicto: idconflicto
          },
          19: {
            valor: valorCampo7,
            idRespuestaIndividual: IdCampo7,
            idRespuestaConflicto: idconflicto
          }
        };

        //////conole.log(this.respuestaSeleccionada);

        break;
      }

      case 4: {

        this.respuestaSeleccionada = {
          7: {
            valor: valorCampo1,
            idRespuestaIndividual: IdCampo1,
            idRespuestaConflicto: idconflicto
          },
          24: {
            valor: valorCampo2,
            idRespuestaIndividual: IdCampo2,
            idRespuestaConflicto: idconflicto
          },
          5: {
            valor: valorCampo3,
            idRespuestaIndividual: IdCampo3,
            idRespuestaConflicto: idconflicto
          },
          10: {
            valor: valorCampo4,
            idRespuestaIndividual: IdCampo4,
            idRespuestaConflicto: idconflicto
          },
          19: {
            valor: valorCampo5,
            idRespuestaIndividual: IdCampo5,
            idRespuestaConflicto: idconflicto
          }
        };

        //////conole.log(this.respuestaSeleccionada);

        break;
      }

      case 5: {

        this.respuestaSeleccionada = {
          20: {
            valor: valorCampo1,
            idRespuestaIndividual: IdCampo1,
            idRespuestaConflicto: idconflicto
          },
          18: {
            valor: valorCampo2,
            idRespuestaIndividual: IdCampo2,
            idRespuestaConflicto: idconflicto
          },
          5: {
            valor: valorCampo3,
            idRespuestaIndividual: IdCampo3,
            idRespuestaConflicto: idconflicto
          },
          45: {
            valor: valorCampo4,
            idRespuestaIndividual: IdCampo4,
            idRespuestaConflicto: idconflicto
          },
          19: {
            valor: valorCampo5,
            idRespuestaIndividual: IdCampo5,
            idRespuestaConflicto: idconflicto
          }
        };

        //////conole.log(this.respuestaSeleccionada);

        break;
      }

      case 6: {

        this.respuestaSeleccionada = {
          16: {
            valor: valorCampo1,
            idRespuestaIndividual: IdCampo1,
            idRespuestaConflicto: idconflicto
          },
          42: {
            valor: valorCampo2,
            idRespuestaIndividual: IdCampo2,
            idRespuestaConflicto: idconflicto
          },
          19: {
            valor: valorCampo3,
            idRespuestaIndividual: IdCampo3,
            idRespuestaConflicto: idconflicto
          }
        };

        //////conole.log(this.respuestaSeleccionada);

        break;
      }

      case 7: {

        this.respuestaSeleccionada = {
          7: {
            valor: valorCampo1,
            idRespuestaIndividual: IdCampo1,
            idRespuestaConflicto: idconflicto
          },
          10: {
            valor: valorCampo2,
            idRespuestaIndividual: IdCampo2,
            idRespuestaConflicto: idconflicto
          },
          8: {
            valor: valorCampo3,
            idRespuestaIndividual: IdCampo3,
            idRespuestaConflicto: idconflicto
          },
          39: {
            valor: valorCampo4,
            idRespuestaIndividual: IdCampo4,
            idRespuestaConflicto: idconflicto
          },
          4: {
            valor: valorCampo5,
            idRespuestaIndividual: IdCampo5,
            idRespuestaConflicto: idconflicto
          },
          5: {
            valor: valorCampo6,
            idRespuestaIndividual: IdCampo6,
            idRespuestaConflicto: idconflicto
          },
          19: {
            valor: valorCampo7,
            idRespuestaIndividual: IdCampo7,
            idRespuestaConflicto: idconflicto
          }
        };

        //////conole.log(this.respuestaSeleccionada);

        break;
      }

      case 8: {

        this.respuestaSeleccionada = {
          44: {
            valor: valorCampo1,
            idRespuestaIndividual: IdCampo1,
            idRespuestaConflicto: idconflicto
          },
          6: {
            valor: valorCampo2,
            idRespuestaIndividual: IdCampo2,
            idRespuestaConflicto: idconflicto
          },
          12: {
            valor: valorCampo3,
            idRespuestaIndividual: IdCampo3,
            idRespuestaConflicto: idconflicto
          },
          4: {
            valor: valorCampo4,
            idRespuestaIndividual: IdCampo4,
            idRespuestaConflicto: idconflicto
          },
          19: {
            valor: valorCampo5,
            idRespuestaIndividual: IdCampo5,
            idRespuestaConflicto: idconflicto
          }
        };

        //////conole.log(this.respuestaSeleccionada);

        break;
      }

      case 9: {

        this.respuestaSeleccionada = {
          40: {
            valor: valorCampo1,
            idRespuestaIndividual: IdCampo1,
            idRespuestaConflicto: idconflicto
          },
          41: {
            valor: valorCampo2,
            idRespuestaIndividual: IdCampo2,
            idRespuestaConflicto: idconflicto
          },
          19: {
            valor: valorCampo3,
            idRespuestaIndividual: IdCampo3,
            idRespuestaConflicto: idconflicto
          }
        };

        //////conole.log(this.respuestaSeleccionada);

        break;
      }

      case 10: {

        this.respuestaSeleccionada = {
          19: {
            valor: valorCampo1,
            idRespuestaIndividual: IdCampo1,
            idRespuestaConflicto: idconflicto
          }
        };

        //////conole.log(this.respuestaSeleccionada);

        break;
      }

      default: {

        break;
      }
    }

    this.global.conflictosnuevoDesdeEncuesta = true;
    this.global.NuevoConflicto = false;
    this.global.EditarConflicto = true;
    this.global.conflictosEditarConflicto = true;
    this.global.PrincipalAdministradorpreguntas = false;
  }

  actualizarOk = {
    titulo: { es: "Conflicto Actualizado", en: "Updated conflict" },
    mensaje: {
      es: "Se actualizo el estado del conflicto",
      en: "The conflict status was updated"
    }
  };


  PermaneceIgualPregunta1(idcampo, idconflicto) {

    this.conflictosService
      .actualizar_registro(idconflicto, this.global.IdFuncionarioTablaFuncionarios)
      .subscribe(datos => {
        //////conole.log(datos);
      });




    if (idcampo == "0") {
      this.ConsultarPreguntas.InsertarValorConflicto(
        idconflicto,
        "Conflicto permanece igual"
      ).subscribe(ArrayResultados => {
        this.ConsultaCamposPregunta(this.global.idconflictoActual);
        Swal.fire(
          this.actualizarOk.titulo[this.global.lenguaje],
          this.actualizarOk.mensaje[this.global.lenguaje],
          "success"
        );
      });
    } else {
      this.ConsultarPreguntas.ActualizarValorConflictoCerrado(
        idcampo,
        "Conflicto permanece igual"
      ).subscribe(ArrayResultados => {
        this.ConsultaCamposPregunta(this.global.idconflictoActual);
        Swal.fire(
          this.actualizarOk.titulo[this.global.lenguaje],
          this.actualizarOk.mensaje[this.global.lenguaje],
          "success"
        );
      });
    }
  }
  ConflictoyanoexistePregunta1(idcampo, idconflicto, preguntas) {

    //conole.log("PREGUNTAS",preguntas)
    let infoConflicto = {
      titulo: this.TituloPregunta1,
      fechaRegistro: preguntas[1].annio
    }

    this.conflictosService
      .cerrarConflicto(
        idconflicto,
        this.global.IdFuncionarioTablaFuncionarios,
        "Conflicto Cerrado desde Encuesta",
        infoConflicto,
        preguntas
      ).subscribe(datos => {
        //////conole.log(datos);
      });



    if (idcampo == "0") {




      this.ConsultarPreguntas.InsertarValorConflicto(
        idconflicto,
        "Conflicto ya no existe"
      ).subscribe(ArrayResultados => {
        this.ConsultaCamposPregunta(this.global.idconflictoActual);
        Swal.fire(
          this.actualizarOk.titulo[this.global.lenguaje],
          this.actualizarOk.mensaje[this.global.lenguaje],
          "success"
        );
      });

    } else {



      this.ConsultarPreguntas.ActualizarValorConflictoCerrado(
        idcampo,
        "Conflicto ya no existe"
      ).subscribe(ArrayResultados => {
        this.ConsultaCamposPregunta(this.global.idconflictoActual);
        Swal.fire(
          this.actualizarOk.titulo[this.global.lenguaje],
          this.actualizarOk.mensaje[this.global.lenguaje],
          "success"
        );
      });

    }


  }

  public ConsultaCamposPregunta(Idpregunta) {

    //////conole.log("ID PREGUNTAAAAAAAAA");
    //////conole.log(Idpregunta);

    switch (Idpregunta) {
      case 1: {

        this.displayedColumnsPregunta1 = [
          // "campo0",
          "campoV",
          "campo1",
          "campo2",
          "campo3",
          "annio",
          "Botones"
        ];


        break;
      }

      case 2: {

        this.displayedColumnsPregunta1 = [
          // "campo0",
          "campoV",
          "campo1",
          "annio",
          "Botones"
        ];


        break;
      }

      case 3: {

        this.displayedColumnsPregunta1 = [
          // "campo0",
          "campoV",
          "campo1",
          "campo2",
          "campo3",
          "campo4",
          "campo5",
          "campo6",
          "campo7",
          "annio",
          "Botones"
        ];


        break;
      }

      case 4: {

        this.displayedColumnsPregunta1 = [
          // "campo0",
          "campoV",
          "campo1",
          "campo2",
          "campo3",
          "campo4",
          "campo5",
          "annio",
          "Botones"
        ];


        break;
      }

      case 5: {

        this.displayedColumnsPregunta1 = [
          // "campo0",
          "campoV",
          "campo1",
          "campo2",
          "campo3",
          "campo4",
          "campo5",
          "annio",
          "Botones"
        ];


        break;
      }

      case 6: {

        this.displayedColumnsPregunta1 = [
          // "campo0",
          "campoV",
          "campo1",
          "campo2",
          "campo3",
          "annio",
          "Botones"
        ];


        break;
      }

      case 7: {

        this.displayedColumnsPregunta1 = [
          //  "campo0",
          "campoV",
          "campo1",
          "campo2",
          "campo3",
          "campo4",
          "campo5",
          "campo6",
          "campo7",
          "annio",
          "Botones"
        ];


        break;
      }

      case 8: {

        this.displayedColumnsPregunta1 = [
          //  "campo0",
          "campoV",
          "campo1",
          "campo2",
          "campo3",
          "campo4",
          "campo5",
          "annio",
          "Botones"
        ];


        break;
      }

      case 9: {

        this.displayedColumnsPregunta1 = [
          //  "campo0",

          "campoV",
          "campo1",
          "campo2",
          "campo3",
          "annio",
          "Botones"
        ];


        break;
      }

      case 10: {

        this.displayedColumnsPregunta1 = [
          // "campo0",
          "campoV",
          "campo1",
          "annio",
          "Botones"
        ];


        break;
      }

      case 11: {

        this.displayedColumnsPregunta1 = [

          //  "campo0",
          "campoV",
          "campo1",
          "campo2",
          "campo3",
          "campo4",
          "campo5",
          "annio",
          "Botones"
        ];


        break;
      }

      default: {



        break;

      }
    }


    ////conole.log("ID pregunta q llega ", Idpregunta)

    if (Idpregunta == 4) {
      this.Arraypregunta1;
      this.respuestas4 = [];
      this.respuestas5 = [];
      this.ocultarNoConflicto = true;

      ////conole.log("PREGUNTA 4")
      this.ConsultarPreguntas.ConsultarConflicto(this.global.IdFuncionarioTablaFuncionarios, Idpregunta).subscribe(
        resPreg4 => {
          ////conole.log("RESPUESTA PREG 4", resPreg4)
          this.ArrayPregunta4A = resPreg4

          //console.log(this.ArrayPregunta4A);
          if (this.ArrayPregunta4A.length == 0) {
            this.Arraypregunta1 = [];
            this.dataSourcePregunta1 = new MatTableDataSource([]);
            this.cg.detectChanges();
          }
          for (let item of this.ArrayPregunta4A) {
            ////conole.log("IDCONFLICTO", item[1].id_respuesta)
            this.ConsultarPreguntas.ConsultaPregunta4(this.global.IdFuncionarioTablaFuncionarios, item[1].id_respuesta).subscribe(
              (rt: any[]) => {

                let response = rt
                ////conole.log("TOTAL DE RESPUESTAS", response)
                let tipoRes = [];
                let tipo4 = [5, 7, 10, 19, 24, 29]
                let tipo5 = [5, 18, 19, 20, 29, 45]
                let contador = 0;
                let contador2 = 0;



                for (let respuesta of response) {
                  for (let number of tipo4) {
                    if (respuesta.id_tipo_respuesta == number) {
                      contador++;
                    }
                  }

                  for (let number2 of tipo5) {
                    if (respuesta.id_tipo_respuesta == number2) {
                      contador2++;
                    }
                  }

                }

                if (contador >= 5) {
                  if (response.length == 5) {
                    response.splice(0, 0, { valor: 'Sin Estado' });
                  }
                  this.respuestas4.push(response)
                  ////conole.log("NUMERO ENCONTRADOS", contador)
                  ////conole.log("RESPUESTA", this.respuestas4)
                }

                if (contador2 >= 5) {
                  ////conole.log("NUMERO ENCONTRADOS", contador2)
                  this.respuestas5.push(response)
                  ////conole.log("RESPUESTA 5", this.respuestas5)

                }

                if (this.respuestas4.length == 0) {
                  this.Arraypregunta1 = [];
                }

                if (this.respuestas5.length == 0) {
                  this.Arraypregunta2 = [];
                }
                for (let ArrayResultados of this.respuestas4) {
                  this.FaltaAccion = false;
                  let count = 0;

                  ////conole.log("ARRAY RES=>", ArrayResultados)



                  let Datos = ArrayResultados;



                  //conole.log("dattooos");
                  //conole.log(Datos);

                  for (let d of Datos) {
                    // //conole.log("D ", d);
                    if (d.annio == this.AnnioActual && d.origen && d.origen == 1) {
                      this.ocultarNoConflicto = false;
                      this.FaltaSiNO = false;
                      if (
                        this.global.lenguaje == "es" ||
                        this.global.lenguaje == "ESPANOL" ||
                        this.global.lenguaje == "ESPAÑOL"
                      ) {
                        this.TextoParaRegistrar = `Si tienes un nuevo conflicto de interés por reportar, haz clic en "SI". En caso contrario, haz clic en “Siguiente Pregunta”.`;
                      } else {
                        this.TextoParaRegistrar = `If you have any additional conflicts for reporting, please click "YES". Otherwise, click "Next Question".`;
                      }
                    }
                  }



                  if (
                    this.global.lenguaje == "es" ||
                    this.global.lenguaje == "ESPANOL" ||
                    this.global.lenguaje == "ESPAÑOL"
                  ) {

                    try {


                      this.Pregunta1ID = "ID";
                      this.Pregunta1annio = "Año";

                      if (Datos[0].valor == "Sin Estado") {
                        ////conole.log("Entra al if");
                        Datos[0].valor = "Registrado"
                        this.Pregunta1CampoV = "Vigencia del Conflicto";
                      }
                      else {
                        ////conole.log("Entra a esto");
                        this.Pregunta1CampoV = Datos[0].nombre;
                      }


                      if (Datos[1]) {
                        this.Pregunta1Campo1 = Datos[1].nombre;
                      }
                      if (Datos[2]) {
                        this.Pregunta1Campo2 = Datos[2].nombre;
                      }
                      if (Datos[3]) {
                        this.Pregunta1Campo3 = Datos[3].nombre;
                      }
                      if (Datos[4]) {
                        this.Pregunta1Campo4 = Datos[4].nombre;
                      }
                      if (Datos[5]) {
                        this.Pregunta1Campo5 = Datos[5].nombre;
                      }
                      if (Datos[6]) {
                        this.Pregunta1Campo6 = Datos[6].nombre;
                      }
                      if (Datos[7]) {
                        this.Pregunta1Campo7 = Datos[7].nombre;
                      }
                      if (Datos[8]) {
                        this.Pregunta1Campo8 = Datos[8].nombre;
                      }



                      ////conole.log("PREG",this.Pregunta1Campo1)

                    } catch (error) {
                      ////conole.log("errror",error);
                    }

                  } else {

                    try {

                      this.Pregunta1ID = "ID";
                      this.Pregunta1annio = "Year";

                      if (Datos[0].valor == "Sin Estado") {
                        ////conole.log("Entra al if");
                        Datos[0].valor = "Registered"
                        this.Pregunta1CampoV = "Conflict validity";
                      }
                      else {
                        ////conole.log("Entra a esto");
                        this.Pregunta1CampoV = "Conflict validity";
                      }


                      if (Datos[1]) {
                        this.Pregunta1Campo1 = Datos[1].ingles;
                      }

                      if (Datos[2]) {
                        this.Pregunta1Campo2 = Datos[2].ingles;
                      }
                      if (Datos[3]) {
                        this.Pregunta1Campo3 = Datos[3].ingles;
                      }
                      if (Datos[4]) {
                        this.Pregunta1Campo4 = Datos[4].ingles;
                      }
                      if (Datos[5]) {
                        this.Pregunta1Campo5 = Datos[5].ingles;
                      }
                      if (Datos[6]) {
                        this.Pregunta1Campo6 = Datos[6].ingles;
                      }
                      if (Datos[7]) {
                        this.Pregunta1Campo7 = Datos[7].ingles;
                      }
                      if (Datos[8]) {
                        this.Pregunta1Campo8 = Datos[8].ingles;
                      }



                    } catch (error) {
                      //////conole.log("errror");
                    }


                  }


                }

                let arreglo = []
                for (let r of this.respuestas4) {
                  arreglo.push(r)
                }
                ////conole.log(arreglo)
                this.Arraypregunta1 = arreglo
                this.dataSourcePregunta1 = new MatTableDataSource(this.Arraypregunta1);
                this.cg.detectChanges();

                if (this.respuestas5.length > 0) {
                  let Datos = this.respuestas5[0];
                  if (
                    this.global.lenguaje == "es" ||
                    this.global.lenguaje == "ESPANOL" ||
                    this.global.lenguaje == "ESPAÑOL"
                  ) {

                    try {


                      this.Pregunta2ID = "ID";
                      this.Pregunta2annio = "Año";

                      if (Datos[0].valor == "Sin Estado") {
                        ////conole.log("Entra al if");
                        Datos[0].valor = "Registrado"
                        this.Pregunta2CampoV = "Vigencia del Conflicto";
                      }
                      else {
                        ////conole.log("Entra a esto");
                        this.Pregunta2CampoV = Datos[0].nombre;
                      }


                      if (Datos[1]) {
                        this.Pregunta2Campo1 = Datos[1].nombre;
                      }
                      if (Datos[2]) {
                        this.Pregunta2Campo2 = Datos[2].nombre;
                      }
                      if (Datos[3]) {
                        this.Pregunta2Campo3 = Datos[3].nombre;
                      }
                      if (Datos[4]) {
                        this.Pregunta2Campo4 = Datos[4].nombre;
                      }
                      if (Datos[5]) {
                        this.Pregunta2Campo5 = Datos[5].nombre;
                      }
                      if (Datos[6]) {
                        this.Pregunta2Campo6 = Datos[6].nombre;
                      }
                      if (Datos[7]) {
                        this.Pregunta2Campo7 = Datos[7].nombre;
                      }
                      if (Datos[8]) {
                        this.Pregunta2Campo8 = Datos[8].nombre;
                      }



                      ////conole.log("PREG",this.Pregunta2Campo1)

                    } catch (error) {
                      ////conole.log("errror",error);
                    }

                  } else {

                    try {

                      this.Pregunta2ID = "ID";
                      this.Pregunta2annio = "Year";

                      if (Datos[0].valor == "Sin Estado") {
                        ////conole.log("Entra al if");
                        Datos[0].valor = "Registered"
                        this.Pregunta2CampoV = "Conflict validity";
                      }
                      else {
                        ////conole.log("Entra a esto");
                        this.Pregunta2CampoV = "Conflict validity";
                      }


                      if (Datos[1]) {
                        this.Pregunta2Campo1 = Datos[1].ingles;
                      }

                      if (Datos[2]) {
                        this.Pregunta2Campo2 = Datos[2].ingles;
                      }
                      if (Datos[3]) {
                        this.Pregunta2Campo3 = Datos[3].ingles;
                      }
                      if (Datos[4]) {
                        this.Pregunta2Campo4 = Datos[4].ingles;
                      }
                      if (Datos[5]) {
                        this.Pregunta2Campo5 = Datos[5].ingles;
                      }
                      if (Datos[6]) {
                        this.Pregunta2Campo6 = Datos[6].ingles;
                      }
                      if (Datos[7]) {
                        this.Pregunta2Campo7 = Datos[7].ingles;
                      }
                      if (Datos[8]) {
                        this.Pregunta2Campo8 = Datos[8].ingles;
                      }



                    } catch (error) {
                      //////conole.log("errror");
                    }


                  }

                  let arreglo = []
                  for (let r of this.respuestas5) {
                    arreglo.push(r)
                  }
                  ////conole.log(arreglo)
                  this.Arraypregunta2 = arreglo
                  this.dataSourcePregunta2 = new MatTableDataSource(this.Arraypregunta2);
                  this.cg.detectChanges();
                }
              }
            )
          }

        });





    }
    else {
      this.Arraypregunta2 = [];
      this.ocultarNoConflicto = true;
      this.FaltaSiNO = true;
      let ocultarExiste = false;
      this.ConsultarPreguntas.ConsultarConflicto(this.global.IdFuncionarioTablaFuncionarios, Idpregunta).subscribe(
        ArrayResultados => {

          //conole.log("arayyy resultadoooos", ArrayResultados);
          this.FaltaAccion = false;
          let count = 0;

          for (let Resultado in ArrayResultados) {

            let ElDatoo = ArrayResultados[Resultado];

            for (let d of ElDatoo) {
              //conole.log("D ", d);
              if (d.annio == this.AnnioActual && d.origen && d.origen == 1) {
                this.ocultarNoConflicto = false;
                this.FaltaSiNO = false;
                if (
                  this.global.lenguaje == "es" ||
                  this.global.lenguaje == "ESPANOL" ||
                  this.global.lenguaje == "ESPAÑOL"
                ) {
                  this.TextoParaRegistrar = `Si tienes un nuevo conflicto de interés por reportar, haz clic en "SI". En caso contrario, haz clic en “Siguiente Pregunta”.`;
                } else {
                  this.TextoParaRegistrar = `If you have any additional conflicts for reporting, please click "YES". Otherwise, click "Next Question".`;
                }
              }
            }



            if (ElDatoo[0].valor == "Sin Estado" && ElDatoo[1].annio != this.AnnioActual) {

              this.FaltaAccion = true;
              //////conole.log(this.FaltaAccion);
              //////conole.log("CONFLICTOS PENDIENTES");
            } else {
              //////conole.log(this.FaltaAccion);
              //////conole.log("NOOO  PENDIENTES");
            }
            //////conole.log("ESTADO CONFLICTOOOOOOOOOOOOOOOOOOOOOOOO", ElDatoo[0].valor);
            //////conole.log("aniooooooooooooooooooooooooooooo", ElDatoo[1].annio);
            count += 1;

          }



          let Datos = ArrayResultados[0];

          //////conole.log("dattooos");
          //////conole.log(Datos);



          if (
            this.global.lenguaje == "es" ||
            this.global.lenguaje == "ESPANOL" ||
            this.global.lenguaje == "ESPAÑOL"
          ) {

            try {


              this.Pregunta1ID = "ID";
              this.Pregunta1annio = "Año";

              if (Datos[0].valor == "Sin Estado") {
                Datos[0].valor = "Registrado"
                this.Pregunta1CampoV = "Vigencia del Conflicto";
              }
              else {
                this.Pregunta1CampoV = Datos[0].nombre;
              }

              this.Pregunta1Campo1 = Datos[1].nombre;
              this.Pregunta1Campo2 = Datos[2].nombre;
              this.Pregunta1Campo3 = Datos[3].nombre;
              this.Pregunta1Campo4 = Datos[4].nombre;
              this.Pregunta1Campo5 = Datos[5].nombre;
              this.Pregunta1Campo6 = Datos[6].nombre;
              this.Pregunta1Campo7 = Datos[7].nombre;
              this.Pregunta1Campo8 = Datos[8].nombre;



            } catch (error) {
              //////conole.log("errror");
            }

          } else {

            try {

              this.Pregunta1ID = "ID";
              this.Pregunta1annio = "Year";
              this.Pregunta1CampoV = Datos[0].ingles;
              this.Pregunta1Campo1 = Datos[1].ingles;
              this.Pregunta1Campo2 = Datos[2].ingles;
              this.Pregunta1Campo3 = Datos[3].ingles;
              this.Pregunta1Campo4 = Datos[4].ingles;
              this.Pregunta1Campo5 = Datos[5].ingles;
              this.Pregunta1Campo6 = Datos[6].ingles;
              this.Pregunta1Campo7 = Datos[7].ingles;
              this.Pregunta1Campo8 = Datos[8].ingles;



            } catch (error) {
              //////conole.log("errror");
            }


          }


          this.Arraypregunta1 = ArrayResultados;

          if (ArrayResultados) {
            this.Arraypregunta1.forEach(arrpreg => {
              // //////conole.log('IMPRIME:',arrpreg);
              arrpreg.forEach(element => {
                if (element && (element.id_tipo_respuesta == "35" || element.id_tipo_respuesta == "36")) {
                  if (element.valor) {
                    //////conole.log('Encuentra tipo fecha para ssplit')
                    element.valor = element.valor.split('T')[0];
                  }
                }
              });
            });

          }




          if (this.Arraypregunta1.length) {
            for (let item of this.Arraypregunta1) {

              // this.esUnico=true;
              // ////conole.log("ITEM ACTUAL",item)

              // if(item[1].id_origen==1 && item[0].Campo1==0){
              //   ////conole.log("ID ORIGEN 1")
              //   this.validarUnico(item[1])
              // }


              if (item[0].valor == "Sin Estado" || item[0].valor == "Registrado") {
                this.listaConflictoEditar.push({ "idCampo": item[0].Campo1, "idRespuesta": item[1].id_respuesta, 'idOrigen': item[1].id_origen })
              }

            }
          }

          ////conole.log("DATA SOURCE", this.Arraypregunta1)

          this.dataSourcePregunta1 = new MatTableDataSource(this.Arraypregunta1);
          this.cg.detectChanges();
        }
      );
    }
  }
  //#endregion "Funciones Pregunta1"

  SeleccionaAccion = {
    titulo: { es: "Error!", en: "Error!" },
    mensaje: {
      es: "Debe Seleccionar una accion para sus conflictos de años anteriores",
      en: "You must select an action for your conflicts from previous years"
    }
  };

  SeleccionaSiNo = {
    titulo: { es: "Error!", en: "Error!" },
    mensaje: {
      es: "Debe Seleccionar Si o No",
      en: "You must select Yes or No"
    }
  };


  SeleccionaOpcion = {
    titulo: { es: "Error!", en: "Error!" },
    mensaje: {
      es: "Debe seleccionar al menos una opcion",
      en: "You must select at least one option"
    }
  };

  SeleccionaAcepta = {
    titulo: { es: "Error!", en: "Error!" },
    mensaje: {
      es: "Debe aceptar los primeros 5 puntos de la Manifestación de Cumplimiento",
      en: "You must accept the first 5 points of the Manifestation of Compliance"
    }
  };







  BotonPregunta1() {
    //conole.log("Pregunta Actual ", this.global.PreguntaActual);
    //conole.log("Falta Accion ", this.FaltaAccion);
    //conole.log("this.FaltaSiNO", this.FaltaSiNO);
    switch (this.global.PreguntaActual) {
      case "2": {

        if (this.FaltaAccion) {
          Swal.fire(
            this.SeleccionaAccion.titulo[this.global.lenguaje],
            this.SeleccionaAccion.mensaje[this.global.lenguaje],
            "error"
          );
        } else {
          if (this.FaltaSiNO) {

            Swal.fire(
              this.SeleccionaSiNo.titulo[this.global.lenguaje],
              this.SeleccionaSiNo.mensaje[this.global.lenguaje],
              "error"
            );
          } else {
            this.respuestaSeleccionada2 = this.global.idconflictoActual
            this.PasarSiguientePregunta();
            this.FaltaSiNO = true;
          }
        }
        break;
      }
      case "3": {
        if (this.FaltaAccion) {
          Swal.fire(
            this.SeleccionaAccion.titulo[this.global.lenguaje],
            this.SeleccionaAccion.mensaje[this.global.lenguaje],
            "error"
          );
        } else {
          if (this.FaltaSiNO) {
            Swal.fire(
              this.SeleccionaSiNo.titulo[this.global.lenguaje],
              this.SeleccionaSiNo.mensaje[this.global.lenguaje],
              "error"
            );
          } else {
            this.respuestaSeleccionada3 = this.global.idconflictoActual
            this.PasarSiguientePregunta();
            this.FaltaSiNO = true;
          }
        }
        break;
      }
      case "4": {
        if (this.FaltaAccion) {
          Swal.fire(
            this.SeleccionaAccion.titulo[this.global.lenguaje],
            this.SeleccionaAccion.mensaje[this.global.lenguaje],
            "error"
          );
        } else {
          if (this.FaltaSiNO) {
            Swal.fire(
              this.SeleccionaSiNo.titulo[this.global.lenguaje],
              this.SeleccionaSiNo.mensaje[this.global.lenguaje],
              "error"
            );
          } else {
            this.respuestaSeleccionada4 = this.global.idconflictoActual
            this.PasarSiguientePregunta();
            this.FaltaSiNO = true;
          }
        }
        break;
      }
      case "5": {
        if (this.FaltaAccion) {
          Swal.fire(
            this.SeleccionaAccion.titulo[this.global.lenguaje],
            this.SeleccionaAccion.mensaje[this.global.lenguaje],
            "error"
          );
        } else {
          if (this.FaltaSiNO) {
            Swal.fire(
              this.SeleccionaSiNo.titulo[this.global.lenguaje],
              this.SeleccionaSiNo.mensaje[this.global.lenguaje],
              "error"
            );
          } else {
            this.respuestaSeleccionada5 = this.global.idconflictoActual
            this.PasarSiguientePregunta();
            this.FaltaSiNO = true;
          }
        }
        break;
      }
      case "6": {
        if (this.FaltaAccion) {
          ////conole.log("FALTA ACCION")
          Swal.fire(
            this.SeleccionaAccion.titulo[this.global.lenguaje],
            this.SeleccionaAccion.mensaje[this.global.lenguaje],
            "error"
          );
        } else {
          if (this.FaltaSiNO) {
            ////conole.log("FALTA SI NO")
            Swal.fire(
              this.SeleccionaSiNo.titulo[this.global.lenguaje],
              this.SeleccionaSiNo.mensaje[this.global.lenguaje],
              "error"
            );
          } else {
            this.respuestaSeleccionada6 = this.global.idconflictoActual
            this.PasarSiguientePregunta();
            this.FaltaSiNO = true;
          }
        }
        break;
      }
      case "7": {
        if (this.FaltaAccion) {
          ////conole.log("FALTA ACCION")
          Swal.fire(
            this.SeleccionaAccion.titulo[this.global.lenguaje],
            this.SeleccionaAccion.mensaje[this.global.lenguaje],
            "error"
          );
        } else {
          if (this.FaltaSiNO) {
            ////conole.log("FALTA SI NO")
            Swal.fire(
              this.SeleccionaSiNo.titulo[this.global.lenguaje],
              this.SeleccionaSiNo.mensaje[this.global.lenguaje],
              "error"
            );
          } else {
            ////conole.log("PASA")
            this.respuestaSeleccionada7 = this.global.idconflictoActual
            this.PasarSiguientePregunta();
            this.FaltaSiNO = true;
          }
        }
        break;
      }
      case "8": {
        if (this.FaltaAccion) {
          Swal.fire(
            this.SeleccionaAccion.titulo[this.global.lenguaje],
            this.SeleccionaAccion.mensaje[this.global.lenguaje],
            "error"
          );
        } else {
          if (this.FaltaSiNO) {
            Swal.fire(
              this.SeleccionaSiNo.titulo[this.global.lenguaje],
              this.SeleccionaSiNo.mensaje[this.global.lenguaje],
              "error"
            );
          } else {
            this.respuestaSeleccionada8 = this.global.idconflictoActual
            this.PasarSiguientePregunta();
            this.FaltaSiNO = true;
          }
        }
        break;
      }
      case "9": {
        if (this.FaltaAccion) {
          Swal.fire(
            this.SeleccionaAccion.titulo[this.global.lenguaje],
            this.SeleccionaAccion.mensaje[this.global.lenguaje],
            "error"
          );
        } else {
          if (this.FaltaSiNO) {
            Swal.fire(
              this.SeleccionaSiNo.titulo[this.global.lenguaje],
              this.SeleccionaSiNo.mensaje[this.global.lenguaje],
              "error"
            );
          } else {
            this.respuestaSeleccionada9 = this.global.idconflictoActual
            this.PasarSiguientePregunta();
            this.FaltaSiNO = true;
          }
        }
        break;
      }
      case "10": {
        if (this.FaltaAccion) {
          Swal.fire(
            this.SeleccionaAccion.titulo[this.global.lenguaje],
            this.SeleccionaAccion.mensaje[this.global.lenguaje],
            "error"
          );
        } else {
          if (this.FaltaSiNO) {
            Swal.fire(
              this.SeleccionaSiNo.titulo[this.global.lenguaje],
              this.SeleccionaSiNo.mensaje[this.global.lenguaje],
              "error"
            );
          } else {
            this.respuestaSeleccionada10 = this.global.idconflictoActual
            this.PasarSiguientePregunta();
            this.FaltaSiNO = true;
          }
        }
        break;
      }
      case "11": {
        if (this.FaltaAccion) {
          Swal.fire(
            this.SeleccionaAccion.titulo[this.global.lenguaje],
            this.SeleccionaAccion.mensaje[this.global.lenguaje],
            "error"
          );
        } else {
          if (this.FaltaSiNO) {
            Swal.fire(
              this.SeleccionaSiNo.titulo[this.global.lenguaje],
              this.SeleccionaSiNo.mensaje[this.global.lenguaje],
              "error"
            );
          } else {
            this.respuestaSeleccionada11 = this.global.idconflictoActual
            this.PasarSiguientePregunta();
            this.FaltaSiNO = true;
          }
        }
        break;
      }
      case "12": {
        if (this.FaltaAccion) {
          Swal.fire(
            this.SeleccionaAccion.titulo[this.global.lenguaje],
            this.SeleccionaAccion.mensaje[this.global.lenguaje],
            "error"
          );
        } else {
          if (this.FaltaSiNO) {
            Swal.fire(
              this.SeleccionaSiNo.titulo[this.global.lenguaje],
              this.SeleccionaSiNo.mensaje[this.global.lenguaje],
              "error"
            );
          } else {
            this.respuestaSeleccionada12 = this.global.idconflictoActual
            this.PasarSiguientePregunta();
            this.FaltaSiNO = true;
          }
        }
        break;
      }
      case "13": {


        if (this.operacionSeleccionada == undefined) {
          Swal.fire(
            this.SeleccionaOpcion.titulo[this.global.lenguaje],
            this.SeleccionaOpcion.mensaje[this.global.lenguaje],
            "error"
          );
        } else {

          this.operacionSeleccionadaPregunta13 = this.operacionSeleccionada;
          this.operacionSeleccionada = this.operacionSeleccionadaPregunta14;

          this.PasarSiguientePregunta();
          this.FaltaSiNO = true;


        }


        break;
      }
      case "14": {


        if (this.operacionSeleccionada == undefined) {
          Swal.fire(
            this.SeleccionaOpcion.titulo[this.global.lenguaje],
            this.SeleccionaOpcion.mensaje[this.global.lenguaje],
            "error"
          );
        } else {
          this.operacionSeleccionadaPregunta14 = this.operacionSeleccionada;
          this.operacionSeleccionada = this.operacionSeleccionadaPregunta15;
          this.PasarSiguientePregunta();
          this.FaltaSiNO = true;


        }

        break;
      }
      case "15": {


        if (this.operacionSeleccionada == undefined) {
          Swal.fire(
            this.SeleccionaOpcion.titulo[this.global.lenguaje],
            this.SeleccionaOpcion.mensaje[this.global.lenguaje],
            "error"
          );
        } else {
          this.operacionSeleccionadaPregunta15 = this.operacionSeleccionada;
          this.operacionSeleccionada = this.operacionSeleccionadaPregunta16;
          this.PasarSiguientePregunta();
          this.FaltaSiNO = true;


        }

        break;
      }
      case "16": {



        if (this.operacionSeleccionada == undefined) {
          Swal.fire(
            this.SeleccionaOpcion.titulo[this.global.lenguaje],
            this.SeleccionaOpcion.mensaje[this.global.lenguaje],
            "error"
          );
        } else {
          this.operacionSeleccionadaPregunta16 = this.operacionSeleccionada;
          this.operacionSeleccionada = this.operacionSeleccionadaPregunta17;
          this.PasarSiguientePregunta();
          this.FaltaSiNO = true;


        }



        break;
      }
      case "17": {


        if (this.operacionSeleccionada == undefined) {
          Swal.fire(
            this.SeleccionaOpcion.titulo[this.global.lenguaje],
            this.SeleccionaOpcion.mensaje[this.global.lenguaje],
            "error"
          );
        } else {
          this.operacionSeleccionadaPregunta17 = this.operacionSeleccionada;
          this.operacionSeleccionada = this.operacionSeleccionadaPregunta18;
          this.PasarSiguientePregunta();
          this.FaltaSiNO = true;


        }


        break;
      }
      case "18": {



        if (this.operacionSeleccionada == undefined) {
          Swal.fire(
            this.SeleccionaOpcion.titulo[this.global.lenguaje],
            this.SeleccionaOpcion.mensaje[this.global.lenguaje],
            "error"
          );
        } else {
          this.operacionSeleccionadaPregunta18 = this.operacionSeleccionada;
          this.PasarSiguientePregunta();
          this.FaltaSiNO = true;

        }


        break;
      }
      case "19": {

        if (this.Pregunta19Checkbox1 && this.Pregunta19Checkbox2 && this.Pregunta19Checkbox3 && this.Pregunta19Checkbox4 && this.Pregunta19Checkbox5) {
          this.PasarSiguientePregunta();
          this.FaltaSiNO = true;
        } else {
          Swal.fire(
            this.SeleccionaAcepta.titulo[this.global.lenguaje],
            this.SeleccionaAcepta.mensaje[this.global.lenguaje],
            "error"
          );
        }


        break;
      }
      default: {
        this.PasarSiguientePregunta();
        this.FaltaSiNO = true;
        break;
      }
    }




  }


  PasarSiguientePregunta() {



    for (let item of this.listaConflictoEditar) {
      if (item.idOrigen == 2) {
        ////conole.log("SE GUARDARA COMO CONTINUA CON CAMBIOS", item)
        /*   this.conflictosService.cambiarEstadoConflicto(item).subscribe(rt=>{
             ////conole.log(rt)
           })
           */
        if (item.idCampo == "0") {
          this.ConsultarPreguntas.InsertarValorConflicto(
            item.idRespuesta,
            "Conflicto permanece igual"
          ).subscribe(ArrayResultados => {
            this.ConsultaCamposPregunta(this.global.idconflictoActual);
          });
        } else {
          this.ConsultarPreguntas.ActualizarValorConflictoCerrado(
            item.idRespuesta,
            "Conflicto permanece igual"
          ).subscribe(ArrayResultados => {
            this.ConsultaCamposPregunta(this.global.idconflictoActual);
          });
        }
      }

    }

    this.EstilobotonNo = false;

    let valor = parseInt(this.global.PreguntaActual);
    valor = valor + 1;
    this.global.PreguntaActual = valor.toString();

    this.ConsultarTodasLasPreguntas(this.global.PreguntaActual);

  }



  BotonAnteriorPregunta1() {
    this.Arraypregunta1;
    this.Arraypregunta2;

    this.EstilobotonNo = false;

    switch (this.global.PreguntaActual) {
      case "14": {
        this.operacionSeleccionadaPregunta14 = this.operacionSeleccionada;
        this.operacionSeleccionada = this.operacionSeleccionadaPregunta13;
        break;
      }
      case "15": {
        this.operacionSeleccionadaPregunta15 = this.operacionSeleccionada;
        this.operacionSeleccionada = this.operacionSeleccionadaPregunta14;
        break;
      }
      case "16": {
        this.operacionSeleccionadaPregunta16 = this.operacionSeleccionada;
        this.operacionSeleccionada = this.operacionSeleccionadaPregunta15;
        break;
      }
      case "17": {
        this.operacionSeleccionadaPregunta17 = this.operacionSeleccionada;
        this.operacionSeleccionada = this.operacionSeleccionadaPregunta16;
        break;
      }
      case "18": {
        this.operacionSeleccionadaPregunta18 = this.operacionSeleccionada;
        this.operacionSeleccionada = this.operacionSeleccionadaPregunta17;
        break;
      }
      case "19": {
        this.operacionSeleccionada = this.operacionSeleccionadaPregunta18;

        break;
      }
      default: {
        break;
      }
    }


    let valor = parseInt(this.global.PreguntaActual);
    valor = valor - 1;
    this.global.PreguntaActual = valor.toString();
    this.ConsultarTodasLasPreguntas(this.global.PreguntaActual);
  }


  BotonFinalizarEncuestaFuncion() {

    let etiquetaCargando = { es: "Guardando", en: "Saving" };
    Swal.fire(etiquetaCargando[this.global.lenguaje]);
    Swal.showLoading();


    let valores12 = {
      "30": this.operacionSeleccionadaPregunta13
    };
    this.conflictosService
      .crearConflicto(this.global.IdFuncionarioTablaFuncionarios, "12", valores12, this.global.lugarConflicto)
      .subscribe(datos => {
        let valores13 = {
          "30": this.operacionSeleccionadaPregunta14
        };
        this.conflictosService
          .crearConflicto(this.global.IdFuncionarioTablaFuncionarios, "13", valores13, this.global.lugarConflicto)
          .subscribe(datos => {
            let valores14 = {
              "30": this.operacionSeleccionadaPregunta15
            };
            this.conflictosService
              .crearConflicto(this.global.IdFuncionarioTablaFuncionarios, "14", valores14, this.global.lugarConflicto)
              .subscribe(datos => {
                let valores15 = {
                  "30": this.operacionSeleccionadaPregunta16
                };
                this.conflictosService
                  .crearConflicto(this.global.IdFuncionarioTablaFuncionarios, "15", valores15, this.global.lugarConflicto)
                  .subscribe(datos => {
                    let valores16 = {
                      "30": this.operacionSeleccionadaPregunta17
                    };
                    this.conflictosService
                      .crearConflicto(this.global.IdFuncionarioTablaFuncionarios, "16", valores16, this.global.lugarConflicto)
                      .subscribe(datos => {

                        let valores17 = {
                          "30": this.operacionSeleccionadaPregunta18
                        };
                        this.conflictosService
                          .crearConflicto(this.global.IdFuncionarioTablaFuncionarios, "17", valores17, this.global.lugarConflicto)
                          .subscribe(datos => {

                            let valores18 = {
                              "33": "SI"
                            };

                            this.conflictosService
                              .crearConflicto(this.global.IdFuncionarioTablaFuncionarios, "18", valores18, this.global.lugarConflicto)
                              .subscribe(datos => {
                                let respuesta19;
                                if (this.Pregunta20Checkbox1) {
                                  respuesta19 = "SI"
                                } else {
                                  respuesta19 = "NO"
                                }

                                let valores19 = {
                                  "31": respuesta19
                                };
                                this.conflictosService
                                  .crearConflicto(this.global.IdFuncionarioTablaFuncionarios, "19", valores19, this.global.lugarConflicto)
                                  .subscribe(datos => {
                                    this.conflictosService.cargarDocusign(this.global.IdFuncionarioTablaFuncionarios, 1, this.global.lenguaje);

                                    Swal.close();
                                    if (
                                      this.global.lenguaje == "es" ||
                                      this.global.lenguaje == "ESPANOL" ||
                                      this.global.lenguaje == "ESPAÑOL"
                                    ) {
                                      Swal.fire(
                                        "Guardado!",
                                        "Se han guardado tus respuestas, por favor revisa tu correo electrónico y finaliza el proceso firmando a través de Docusign",
                                        "success"
                                      );
                                    } else {
                                      Swal.fire(
                                        "Saved!",
                                        "Your answers have been saved, please check your email and finish the process by signing through Docusign",
                                        "success"
                                      );
                                    }

                                    this.router.navigate(["/ResumenConflictos"]);

                                    this.conflictosService
                                      .Actualizarfecha(this.global.IdFuncionarioTablaFuncionarios)
                                      .subscribe(datos => {
                                        //////conole.log(datos);
                                      });
                                  });
                              });
                          });
                      });
                  });
              });
          });
      });


  }

  Es() {
    this.global.lenguaje = "es";
    this.ngOnInit();
  }

  En() {
    this.global.lenguaje = "en";
    this.ngOnInit();
  }


  validarDatos() {

    let encontrado = false;
    for (let item of this.global.listaConflictoSI) {
      if (item.idPregunta == this.global.idconflictoActual) {
        encontrado = true;
        return encontrado
      }
    }



  }


  validarUnico(item) {

    this.conflictosService.validarRegUnico(item).subscribe(
      (rt: any[]) => {
        ////conole.log("ES UNICO?", rt)

        if (rt.length) {
          ////conole.log("NO ES UNICO")
          this.esUnico = true
        }
        else {
          ////conole.log("SI ES UNICO")
          this.esUnico = false
        }
      }
    )
  }


}
